'use strict';

var mod = require('../helpers/mod');

// https://262.ecma-international.org/5.1/#sec-5.2

module.exports = function modulo(x, y) {
	return mod(x, y);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/modulo.js
// module id = 63
// module chunks = 0